import { render, staticRenderFns } from "./icon-receipt.vue?vue&type=template&id=171a8ec4&scoped=true&"
import script from "./icon-receipt.vue?vue&type=script&lang=js&"
export * from "./icon-receipt.vue?vue&type=script&lang=js&"
import style0 from "./icon-receipt.vue?vue&type=style&index=0&id=171a8ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a8ec4",
  null
  
)

export default component.exports